// extracted by mini-css-extract-plugin
module.exports = {"label":"FormInput_label__2z--5","large":"FormInput_large__2RDL0"};